// Leadera brand mark — uses the client-provided logotype
const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_quote-flow-55/artifacts/d92min1n_WhatsApp%20Image%202026-07-06%20at%2022.26.05.jpeg";

export default function Logo({ size = "md" }) {
  const heights = { sm: "h-8", md: "h-12", lg: "h-16", xl: "h-24" };
  return (
    <div className="inline-flex items-center" data-testid="leadera-logo">
      <img
        src={LOGO_URL}
        alt="Leadera"
        className={`${heights[size] || heights.md} w-auto object-contain`}
      />
    </div>
  );
}
